import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// ─── Carrega fonte Manrope do Google Fonts ────────────────────────────────
// Pesos: 400 (regular), 500 (medium), 600 (semibold), 700 (bold)
// A fonte é APLICADA por componente (não global) — esta tag só faz o download.
const linkPreconnect = document.createElement('link');
linkPreconnect.rel = 'preconnect';
linkPreconnect.href = 'https://fonts.googleapis.com';
document.head.appendChild(linkPreconnect);

const linkPreconnectStatic = document.createElement('link');
linkPreconnectStatic.rel = 'preconnect';
linkPreconnectStatic.href = 'https://fonts.gstatic.com';
linkPreconnectStatic.crossOrigin = 'anonymous';
document.head.appendChild(linkPreconnectStatic);

const linkFont = document.createElement('link');
linkFont.rel = 'stylesheet';
linkFont.href = 'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700&display=swap';
document.head.appendChild(linkFont);

// Reset global mínimo de CSS
const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background-color: #f0f2f7; }
  input, button { font-family: inherit; }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
